<template>
  <wizard-form v-on="$listeners" v-bind="$attrs">
    <template #content>
      <v-row>
        <v-col cols="12" class="mb-5">
          <h1 class="primary--text font-weight-medium">
            {{ $t('security_transfer_authorization') }}
          </h1>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model="securityTransfer.observations"
            :label="$t('security_transfer_observations')"
            dense
            autocomplete="nope"
            maxlength="128"
            hide-details="auto"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <div class="text-h6 font-weight-bold">
            {{ $t('security_transfer_request_authorization_file_title') }}
            <span v-if="requiredDocument">*</span>
          </div>
          <p class="mb-2">
            {{ $t('security_transfer_request_authorization_file_description') }}
          </p>
          <ul class="mb-2">
            <li>{{ $t('security_transfer_request_authorization_file_item_1') }}</li>
            <li>{{ $t('security_transfer_request_authorization_file_item_2') }}</li>
            <li>{{ $t('security_transfer_request_authorization_file_item_3') }}</li>
            <li>{{ $t('security_transfer_request_authorization_file_item_4') }}</li>
            <li>{{ $t('security_transfer_request_authorization_file_item_5') }}</li>
          </ul>
          <ValidationProvider
            vid="support_doc"
            :name="$t('transfer_request_authorization_document_upload')"
            :rules="`${requiredDocument ? 'required' : ''}|ext:pdf|size:5000`"
            v-slot="{ errors }"
          >
            <v-file-input
              v-model="supportFile"
              accept=".pdf"
              dense
              show-size
              outlined
              class="pt-2"
              hide-details="auto"
              truncate-length="150"
              :placeholder="$t('transfer_request_authorization_document_upload')"
              :error-messages="errors[0]"
              @change="handleSupportFile($event)"
              @click:clear="clearSupportFile()"
            />
          </ValidationProvider>
        </v-col>
      </v-row>
    </template>
  </wizard-form>
</template>
<script>
import WizardForm from '@/components/commons/WizardForm'
import { mapState } from 'vuex'
export default {
  components: {
    WizardForm
  },
  props: {
    securityTransfer: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      supportFile: null
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('account', ['account', 'authorityAccounts']),
    isExecutive() {
      return (
        this.user?.authorityLevelsCode === 1 ||
        this.user?.authorityLevelsCode === 2 ||
        this.user?.authorityLevelsCode === 4
      )
    },
    isAccountCode() {
      return (
        this.user?.avobjects?.findIndex(
          item =>
            item.code === this.account.code && item.typeCode === 'accountCode'
        ) > -1
      )
    },
    requiredDocument() {
      return this.securityTransfer.transferType !== 'Receive'
    }
  },
  watch: {
    'securityTransfer.transferType': {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.securityTransfer.observations = null
          this.supportFile = null
          this.securityTransfer.supportFile = null
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    handleSupportFile(file) {
      if (!file) {
        this.securityTransfer.supportFile = null
        return
      }
      const reader = new FileReader()
      reader.onloadend = () => {
        this.securityTransfer.supportFile = reader.result
      }
      reader.readAsDataURL(file)
    },
    clearSupportFile() {
      this.supportFile = null
    }
  }
}
</script>
<style scoped>
.main-container {
  line-height: normal;
}

hr {
  margin: 0;
  padding: 0;
}

hr.rounded {
  border-top: 2px solid;
  width: 400px;
}
</style>
